// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","separator":"Separator_separator__Ve42i"};